import React from "react";
import "./Hero.css";
import Header from "../Header/Header";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import Heart from "../../assets/heart.png";
import Calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import { useState } from "react";
import NumberCounter from "number-counter"

const Hero = () => {
  const transition = { type: "spring", duration: 5 };
  const mobile=window.innerWidth<=768 ?true : false;
  return (
    <div className="Hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-Hero">
        <Header />
        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile? "165px":"238px" }}
            whileInView={{ left: "8px" }}
            transition={transition}
          ></motion.div>
          <span>The Best Fitness Club In The Town</span>
        </div>
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal Body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest.
            </span>
          </div>
        </div>
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={140} start={100} delay="5" preFix='+' />
            </span>
            <span>Expert Coachs</span>
          </div>
          <div>
            <span>
            <NumberCounter end={978} start={920} delay="5" preFix='+' />
            </span>
            <span>members joined</span>
          </div>
          <div>
            <span>
            <NumberCounter end={50} start={21} delay="5" preFix='+' />
            </span>
            <span>fitness Program</span>
          </div>
        </div>
        <div className="hero-buttons">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      <div className="right-Hero">
        <button className="btn">Join Now</button>

        <motion.div
          className="heart-rate"
          transition={transition}
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
        >
          <img src={Heart} alt=""></img>
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img 
        transition={transition}
        initial={{right:"11rem"}}
        whileInView={{right:"20rem"}}
        src={hero_image_back} alt="" className="hero-image-back" />
        <motion.div
          className="calories"
          transition={transition}
          initial={{ right: "37rem" }}
          whileInView={{ right: "28rem" }}
        >
          <img src={Calories} alt="" />
          <div>
            <span>Calories Burned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
export default Hero;
